export const GOOGLE = 'AIzaSyAGYNF7CsKNyuEzENLLdYW1ELf5tBi74Ic';
export const LOCATION_IQ = 'pk.636998e41ff11d153db57d8cb28e5ec8';